import en from "@/i18n/en.json";
import de from "@/i18n/de.json";
import fr from "@/i18n/fr.json";
import es from "@/i18n/es.json";

export const LANGS = [
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "en", label: "English", flag: "EN" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "es", label: "Español", flag: "ES" },
];
export const DICTS = { en, de, fr, es };

function detect() {
  const saved = localStorage.getItem("lang");
  if (saved && LANGS.some((l) => l.code === saved)) return saved;
  const nav = (navigator.languages || [navigator.language || "en"]).map((l) => l.slice(0, 2).toLowerCase());
  return nav.find((c) => LANGS.some((l) => l.code === c)) || "en";
}

let current = detect();
document.documentElement.lang = current;

export const getLang = () => current;

export function setLangGlobal(code) {
  current = code;
  localStorage.setItem("lang", code);
  document.documentElement.lang = code;
}

// Source strings are Italian; returns the translation for the active language
export function t(s) {
  if (current === "it" || typeof s !== "string") return s;
  return DICTS[current]?.[s] ?? s;
}

// Translate then fill {placeholders}
export const tf = (s, vars) => t(s).replace(/\{(\w+)\}/g, (_, k) => vars?.[k] ?? "");

// All translations of an Italian string
export const allTranslations = (s) => [s, ...Object.values(DICTS).map((d) => d[s]).filter(Boolean)];
